import i18nFactory from '@yandex-int/i18n';

import { ValidationErrorData } from '../../typings/common';

import * as keyset from './ShowsFrequencyEditorHelpers.i18n';

const i18n = i18nFactory(keyset);

export const validateShowsLimit = (showsLimit: string): ValidationErrorData[] => {
    if (showsLimit.length === 0) {
        return [
            {
                code: 'empty-shows-limit',
                text: i18n('empty-shows-limit')
            }
        ];
    }

    return [];
};

export const validateCustomPeriod = (customPeriod: string): ValidationErrorData[] => {
    if (customPeriod.length === 0) {
        return [
            {
                code: 'empty-custom-period',
                text: i18n('empty-custom-period')
            }
        ];
    }

    return [];
};
